import { render, staticRenderFns } from "./crm-expired-show.vue?vue&type=template&id=85fea9aa&"
import script from "./crm-expired-show.vue?vue&type=script&lang=js&"
export * from "./crm-expired-show.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports